import { Component, OnInit } from '@angular/core';
//import { AuthServiceService } from '../../services/auth-service.service';
import { INewUser, IUserProfile } from '../../interfaces/';
import { NewUser, UserProfile } from '../../models/';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
  selector: 'app-table-management',
  templateUrl: './table-management.component.html',
  styleUrls: ['./table-management.component.css']
})
export class TableManagementComponent implements OnInit {

	message: string = "";

  isAuthenticated: boolean = false;
  Loading: boolean= false;

  constructor(private router: Router) { }

  ngOnInit() {
    if(sessionStorage.getItem("token")){
      let obj = JSON.parse(sessionStorage.getItem("token"));
      if(obj && obj.Token != ""){
        this.isAuthenticated = true;
      }
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/admin-module/table-management/table-management.component.ts